module.exports = __webpack_public_path__ + "img/ic_temp.70f0a699.svg";